import { isBusinessOrExecutiveMembership } from "../../utils/membershipTier";

export type HelpCategoryId =
  | "bug"
  | "improvement"
  | "general"
  | "collaboration";

export type HelpCategory = {
  id: HelpCategoryId;
  titleKey: string;
  descKey: string;
  /** Only Business / Executive membership can see and use this category. */
  proOnly?: boolean;
};

export const HELP_CATEGORIES: HelpCategory[] = [
  {
    id: "bug",
    titleKey: "help.category.bug.title",
    descKey: "help.category.bug.desc",
  },
  {
    id: "improvement",
    titleKey: "help.category.improvement.title",
    descKey: "help.category.improvement.desc",
  },
  {
    id: "general",
    titleKey: "help.category.general.title",
    descKey: "help.category.general.desc",
  },
  {
    id: "collaboration",
    titleKey: "help.category.collaboration.title",
    descKey: "help.category.collaboration.desc",
  },
];

export type HelpScreenOption = {
  key: string;
  /** Only Business / Executive can see this screen option (e.g. Muslim Invest). */
  proOnly?: boolean;
};

/**
 * Screens members can report on — mirrors sidebar access.
 * Muslim Invest is Business / Executive only (hidden for Youth / Early Stage).
 * "Other" is always included.
 */
export const HELP_SCREEN_OPTIONS: HelpScreenOption[] = [
  { key: "help.screen.updates" },
  { key: "help.screen.dashboard" },
  { key: "help.screen.events" },
  { key: "help.screen.partners" },
  { key: "help.screen.messages" },
  { key: "help.screen.connections" },
  { key: "help.screen.muslimInvest", proOnly: true },
  { key: "help.screen.attendeeNotes" },
  { key: "help.screen.myAccount" },
  { key: "help.screen.other" },
];

/** Screen keys visible for the given membership (or all non-pro if unknown). */
export function getHelpScreenKeysForMembership(
  membershipName?: string | null
): string[] {
  const canAccessPro = isBusinessOrExecutiveMembership(membershipName);
  return HELP_SCREEN_OPTIONS.filter(
    (screen) => !screen.proOnly || canAccessPro
  ).map((screen) => screen.key);
}

/** @deprecated Prefer HELP_SCREEN_OPTIONS / getHelpScreenKeysForMembership */
export const HELP_SCREEN_KEYS = HELP_SCREEN_OPTIONS.map((s) => s.key);

/** @deprecated Use HELP_SCREEN_KEYS / getHelpScreenKeysForMembership */
export const BUG_SCREEN_KEYS = HELP_SCREEN_KEYS;
